/**
 * Upload invoice file (本地模式 - 不实际上传到云端)
 * @param file - File to upload
 * @param userId - User ID for organizing files
 * @returns Mock result with local URL
 */
export const uploadInvoice = async (file: File, userId: string = 'guest') => {
  try {
    // Create unique filename
    const timestamp = Date.now();
    const fileName = `invoices_${userId}_${timestamp}_${file.name}`;

    // 创建本地 URL
    const localUrl = URL.createObjectURL(file);

    console.log('File prepared locally:', fileName);

    return {
      success: true,
      url: localUrl,
      fileID: `local_${timestamp}`,
      path: fileName
    };
  } catch (error: any) {
    console.error('Upload error:', error);
    return {
      success: false,
      error: error.message || '文件处理失败'
    };
  }
};

/**
 * Delete invoice file (本地模式 - 释放本地 URL)
 * @param fileID - File ID
 */
export const deleteInvoice = async (fileID: string) => {
  try {
    // 本地模式无需实际删除
    console.log('File reference removed:', fileID);
    return { success: true };
  } catch (error: any) {
    console.error('Delete error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Convert File to Base64 string (useful for OCR)
 * @param file - File to convert
 * @returns Base64 string
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result as string;
      // Remove data:image/jpeg;base64, prefix
      const base64 = base64String.split(',')[1];
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  });
};
